import { Link, useLocation } from "react-router-dom";
import "./AppSwitcher.css";

const APPS = [
  { path: "/", label: "금뚝딱" },
  { path: "/bokiori", label: "복이오리" },
];

function AppSwitcher() {
  const { pathname } = useLocation();

  return (
    <nav className="app-switcher" aria-label="앱 전환">
      {APPS.map((app) => (
        <Link
          key={app.path}
          to={app.path}
          className={`app-switcher-item ${pathname === app.path ? "active" : ""}`}
        >
          {app.label}
        </Link>
      ))}
    </nav>
  );
}

export default AppSwitcher;
